import {  ReactElement } from "react";
import { Button, Card, Grid2 as Grid } from "@mui/material";
import ImageComponent from "../shared/ImageComponent";
import { FacebookIcon, EmailIcon, WhatsappIcon } from "react-share";
import { Item } from "../shared/Item";
import { article } from "./ArticleInterfaces";

const categoryMap: Record<number, string> = {
  1: "RENT AN INFLATABLE",
  2: "BUY AN INFLATABLE",
  3: "RENT PARTY EQUIPMENT",
};

const handleCallURL = (action: string) => {
  switch (action) {
    case 'email':
      window.location.href = "mailto:contacto@superfun-nwa.com";
      break;
    case 'fb':
      window.location.href = "https://fb.com";
      break;
    default:
      window.location.href ="whatsapp://send?text=" + window.location.href
      break;
  }

}

const SingleArticle = ({
  data,
  isSingle = false,
}: {
  data: article;
  isSingle?: boolean;
}): ReactElement => {
  const shareMe = () => {
    return (
      <>
        <EmailIcon size={30} round={true} onClick={() => handleCallURL('email')} />
        <FacebookIcon size={30} round={true} onClick={() => handleCallURL('fb')} />
        <WhatsappIcon size={30} round={true} onClick={() => handleCallURL('whatsapp')} />
      </>
    );
  };

  const printComponent = () => {
    return (
      <>
        <Card
          sx={[
            {
              width: "auto",
              textDecoration: "underline",
            },
          ]}
        >
          <Grid container spacing={2}>
            <Grid size={12}>
              <Item>
                <ImageComponent articleId={data.id} />
              </Item>
            </Grid>
            <Grid size={4}>
              <Item>Title</Item>
            </Grid>
            <Grid size={8}>
              <Item>{data.title}</Item>
            </Grid>
            <Grid size={4}>
              <Item>Category</Item>
            </Grid>
            <Grid size={8}>
              <Item style={{ fontStyle: "italic", color: "gray" }}>
                {categoryMap[data.cat_id] ?? "Uncategorized"}
              </Item>
            </Grid>
            <Grid size={12}>
              <Item>{data.content}</Item>
            </Grid>
            <Grid size={8} />
            <Grid size={4}>
              <Item>
                {isSingle ? (
                  shareMe()
                ) : (
                  <Button title="Details" href={`/article/${data.id}`}>
                    Details
                  </Button>
                )}
              </Item>
            </Grid>
          </Grid>
          <p />
        </Card>
        <p />
      </>
    );
  };

  return <>{data.active && printComponent()}</>;
};

export default SingleArticle;
